/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect } from 'react';

type ResizeListener = {
    (element: Element, set: (dimensions: [number, number]) => void): () => void;
};

// All modern browsers sans-IE
const initResizeObserverListener: ResizeListener = (element, set) => {
    const ro = new ResizeObserver((entries: ResizeObserverEntry[]) => {
        const {
            contentRect: { width, height }
        } = entries[0];

        set([width, height]);
    });

    ro.observe(element);

    return () => ro.disconnect();
};

// Predominantly IE fallback
const initWindowResizeListener: ResizeListener = (element, set) => {
    const onWindowResize = () => {
        const boundingRect = element.getBoundingClientRect();

        set([boundingRect?.width || 0, boundingRect?.height || 0]);
    };
    onWindowResize();
    window.addEventListener('resize', onWindowResize);

    return () => window.removeEventListener('resize', onWindowResize);
};

const useContainerMeasurement = (
    containerRef: React.RefObject<HTMLDivElement>
) => {
    const [containerDimensions, setContainerDimensions] = useState([0, 0]);

    useEffect(() => {
        if (!containerRef.current) {
            return;
        }

        // Legacy codepath - this can be removed once IE11 support is dropped
        if (!window.ResizeObserver) {
            return initWindowResizeListener(
                containerRef.current,
                setContainerDimensions
            );
        }

        return initResizeObserverListener(
            containerRef.current,
            setContainerDimensions
        );
    }, []);

    return containerDimensions;
};

export default useContainerMeasurement;
